class ComponentProductCard extends HTMLElement {
  constructor() {
    super();
    this.carouselElement = this.querySelector(".carousel .keen-slider-card");
    this.videoPlayButton = this.querySelector(".play-btn");
    this.videoPauseButton = this.querySelector(".pause-btn");
    this.video = this.querySelector(".video-plp");
    this.carousel = null;
    this.product_type = this.querySelector('.options-group').getAttribute('data-product-type');
    this.product_option1 = this.querySelector(".options-1");
    this.product_option2 = this.querySelector(".options-2");
    this.product_swatches = this.querySelectorAll(".btn-option");
    this.price_selector = this.querySelector('.final');
    this.compare_price_selector = this.querySelector('.compare');
    this.product_slider_container = this.querySelector('.keen-slider-card');
    this.product_slides = this.querySelectorAll('.keen-slider-slide');
    this.subtitle = this.querySelector('.description');
    this.product_swatches.forEach((button) => {
      button.addEventListener("click", this.handleSwatchChange.bind(this));
    });
    
    if (this.carouselElement) {
      setTimeout(() => {
        //The timeout is for the customizer
        this.initCarousel();
      }, 1);
    }
    if (this.videoPlayButton){
      this.videoPlayButton.addEventListener("click", this.playVideo.bind(this));
    }
    if (this.videoPauseButton){
      this.videoPauseButton.addEventListener("click", this.pauseVideo.bind(this));
    }
  }
  playVideo(){
    this.video.play();
    this.videoPlayButton.classList.add("hide");
    this.videoPauseButton.classList.remove("hide");
  } 
  pauseVideo(){
    this.video.pause();
    this.videoPlayButton.classList.remove("hide");
    this.videoPauseButton.classList.add("hide");
  }
  initCarousel() {
    if (this.carousel) {
      this.carousel.destroy();
    }
    const config = {
      prevButton: this.querySelector(".keen-arrow.prev"),
      nextButton: this.querySelector(".keen-arrow.next"),
      // dots: this.querySelector(".keen-dots"),
    };
    this.carousel = new KeenSlider(this.carouselElement, config);
  }

  updateSliderOptions(data_variant_option,url) {
    // Select product images that match the variant option
    // console.log(data_variant_option,url);
    const productImages = this.querySelectorAll(`.product-image-container .product-image[data-variant-option="${data_variant_option}"]`);
    // console.log('Matching product images:', productImages);
    const existingSlides = this.product_slider_container.querySelectorAll(`.keen-slider-slide[data-variant-option="${data_variant_option}"]`);
    // console.log('Existing slides:', existingSlides.length, 'Product images:', productImages.length);
    if (existingSlides.length === 0) {
      // Create up to 4 slides from product images
      let count = 0;
      productImages.forEach((img) => {
        if (count < 5) {
          const slide = document.createElement('div');
          slide.className = 'keen-slider-slide';
          slide.setAttribute('data-variant-option', data_variant_option);
          const link = document.createElement('a');
          link.href = url;
          const imageDiv = document.createElement('div');
          imageDiv.className = 'image';
          const imgElement = document.createElement('img');
          imgElement.className = 'img';
          imgElement.loading = 'lazy';
          imgElement.src = img.getAttribute('data-img');
          imgElement.alt = img.getAttribute('data-img-alt');
          imageDiv.appendChild(imgElement);
          link.appendChild(imageDiv);
          slide.appendChild(link);
          this.product_slider_container.appendChild(slide);
          count++;
        }
      });
    }
  }

  filterSlides(activeOption,url){
    this.updateSliderOptions(activeOption,url);
    var count = 0;
    this.product_slider_container.querySelectorAll('.keen-slider-slide').forEach((slide) => {
      var slide_option = slide.getAttribute('data-variant-option');
      if(slide_option === activeOption && count < 4){
        slide.classList.remove('hide');
        count++;
      } else {
        slide.classList.add('hide');
      }
    });
    this.initCarousel();
  }
  updateVariant(activeVariant, filter){
    const price = activeVariant.getAttribute('data-price');
    const compareAtPrice = activeVariant.getAttribute('data-compare-at-price');
    const variantId = activeVariant.getAttribute('data-variant-id');
    this.price_selector.textContent = price;
    if(this.subtitle){
      this.subtitle.textContent = filter;
    }
    if(compareAtPrice !== '0'){
      this.compare_price_selector.textContent = compareAtPrice;
      this.compare_price_selector.classList.remove('hide');
    } else {
      this.compare_price_selector.textContent = '';
      this.compare_price_selector.classList.add('hide');
    }
    const anchorTags = this.querySelectorAll('a');
    anchorTags.forEach(anchor => {
        // Check if the URL already has a variant parameter
        if (anchor.href.includes('?variant=')) {
          anchor.href = anchor.href.replace(/\?variant=\d+/, `?variant=${variantId}`);
        } else {
          const separator = anchor.href.includes('?') ? '&' : '?';
          anchor.href = `${anchor.href}${separator}variant=${variantId}`;
        }
    });
  }
  updateVariantLink(activeVariant){
    const variantId = activeVariant.getAttribute('data-variant-id');
    var url = this.querySelector('.product-card-url a').href;
    if(url.includes('?variant=')){
      url = url.replace(/\?variant=\d+/, `?variant=${variantId}`);
    } else {
      const separator = url.includes('?') ? '&' : '?';
      url = `${url}${separator}variant=${variantId}`;
    }
    return url;
  }
  handleSwatchChange(e){
    e.preventDefault();
    e.target.closest('.options').querySelectorAll('.btn-option').forEach((btn) => btn.classList.remove("selected"));
    e.target.classList.add("selected");
    const activeOption1 = this.product_option1.querySelector('.selected').getAttribute('data-value');
    let filter;
    if(this.product_type.includes('Engagement Ring')){
      const activeOption2 = this.product_option2.querySelector('.selected').getAttribute('data-value');
      filter = activeOption1 + ' / ' + activeOption2;
    } else{
      filter = activeOption1;
    }
    // console.log(filter);
    const activeVariant = this.querySelector(`[data-variant-option="${filter}"]`);
    this.updateVariant(activeVariant,filter);
    const url = this.updateVariantLink(activeVariant);
    this.filterSlides(activeVariant.getAttribute('data-variant-option'),url);
  }
}
customElements.define("product-card", ComponentProductCard);
